import React, { useContext, useState } from 'react';
import { AuthContext } from '../AuthContext';
import { Building2, LogOut } from 'lucide-react';
import styles from './Login.module.css';

function ServiceCenterSelect() {
    const { selectServiceCenter, serviceCenters, logoutUser, loading } = useContext(AuthContext);
    const [error, setError] = useState(null);

    const handleSelect = (center) => {
        if (!center.id) return;
        setError(null);
        selectServiceCenter(center);
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginBox}>

                <div className={styles.logoSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo.png" alt="CONNEXTA SYSTEM" className={styles.logoImage} />
                    </div>
                </div>

                <p className={styles.subtitle}>
                    Выберите склад для входа
                </p>

                {error && <div className={styles.alert}>{error}</div>}

                <div className={styles.loginForm}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                            <div className={styles.loadingSpinner} style={{ margin: '0 auto 0.75rem' }} />
                            <p className={styles.mutedText}>Загрузка...</p>
                        </div>
                    ) : serviceCenters.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                            <p className={styles.mutedText}>
                                Нет доступных складов.<br />Обратитесь к администратору.
                            </p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem', maxHeight: '240px', overflowY: 'auto' }}>
                            {serviceCenters.map((center, index) => {
                                const disabled = !center.id;
                                return (
                                    <div
                                        key={center.id || index}
                                        onClick={() => !disabled && handleSelect(center)}
                                        className={styles.inputWrapper}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.875rem',
                                            padding: '0.875rem 1rem',
                                            cursor: disabled ? 'not-allowed' : 'pointer',
                                            opacity: disabled ? 0.45 : 1,
                                            transition: 'all 0.2s ease',
                                            borderRadius: '14px',
                                        }}
                                    >
                                        <Building2 style={{ width: 18, height: 18, color: '#94a3b8', flexShrink: 0 }} />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.92rem' }}>{center.name}</div>
                                            {center.address && (
                                                <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: '0.1rem' }}>{center.address}</div>
                                            )}
                                            {disabled && (
                                                <div style={{ fontSize: '0.75rem', color: '#ef4444' }}>Недоступен</div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    <button
                        onClick={logoutUser}
                        disabled={loading}
                        className={styles.secondaryButton}
                    >
                        <LogOut style={{ width: 16, height: 16 }} />
                        Выйти из системы
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ServiceCenterSelect;
